/* eslint-disable @atlaskit/editor/no-re-export */
// Entry file in package.json
// Barrel kept for existing consumers -- new call sites should import from the
// `@atlaskit/insm/api` entry point instead.
export { init, insm } from './api';
